//#region src/modules/core/utils/functions.ts
var isNotEmptyOrNull = (string) => Boolean(string);
//#endregion
export { isNotEmptyOrNull };
